export interface ModellvariantenM2 {
  resultate: Resultate;
  koeffiziente: Koeffiziente;
}

export interface Koeffiziente {
  analyseNurGrundlohn: KoeffizienteAnalyseFixeGewichtung;
  analyseFixeGewichtung: KoeffizienteAnalyseFixeGewichtung;
  standardAnalyseModell: KoeffizienteAnalyseFixeGewichtung;
}

export interface KoeffizienteAnalyseFixeGewichtung {
  gewichtungAusbildung?: number;
  gewichtungAutonomie?: number;
  gewichtungSpezifischesWissen?: number;
  gewichtungVerantwortung?: number;
  gewichtungPsychosozial?: number;
  gewichtungKoerperlich?: number;
  kendallTauB?: number;
  pearson?: number;
  nurTest1?: string;
  nurTest2?: string;
  nurTest3?: string;
  test1Plus2?: string;
  test1Plus3?: string;
  test2Plus3?: string;
  alleTests?: string;
  koeffizientKonstante?: string;
  koeffizientFunktionswert?: string;
  koeffizientAlter?: string;
  koeffizientDienstjahre?: string;
  r2?: number;
}

export interface Resultate {
  analyseNurGrundlohn: ResultateAnalyseFixeGewichtung;
  analyseFixeGewichtung: ResultateAnalyseFixeGewichtung;
  standardAnalyseModell: ResultateAnalyseFixeGewichtung;
}

export interface ResultateAnalyseFixeGewichtung {
  anzahlRisikopaareZuUngunstenMaenner?: string;
  durchschnittlicheLohnunterschiedeMaenner?: string;
  anzahlRisikopaareZuUngunstenFrauen?: string;
  durchschnittlicheLohnunterschiedeFrauen?: string;
  gesamtscore?: number;
  zuUngunstenDerFrauen?: boolean;
  anzahlDerRisikopaare?: number;
  gemischtgeschlechtlichePaare?: number;
  anteilRisikopaare?: string;
}

export class ModellVariablenKoefficienteM2 {
  gewichtungAusbildung: KoeffizienteM2RowData;
  gewichtungAutonomie: KoeffizienteM2RowData;
  gewichtungSpezifischesWissen: KoeffizienteM2RowData;
  gewichtungVerantwortung: KoeffizienteM2RowData;
  gewichtungPsychosozial: KoeffizienteM2RowData;
  gewichtungKoerperlich: KoeffizienteM2RowData;
  kendallTauB: KoeffizienteM2RowData;
  pearson: KoeffizienteM2RowData;
  nurTest1: KoeffizienteM2RowData;
  nurTest2: KoeffizienteM2RowData;
  nurTest3: KoeffizienteM2RowData;
  test1Plus2: KoeffizienteM2RowData;
  test1Plus3: KoeffizienteM2RowData;
  test2Plus3: KoeffizienteM2RowData;
  alleTests: KoeffizienteM2RowData;
  koeffizientKonstante: KoeffizienteM2RowData;
  koeffizientFunktionswert: KoeffizienteM2RowData;
  koeffizientAlter: KoeffizienteM2RowData;
  koeffizientDienstjahre: KoeffizienteM2RowData;
  r2: KoeffizienteM2RowData;
  constructor() {
    this.gewichtungAusbildung = new KoeffizienteM2RowData();
    this.gewichtungAutonomie = new KoeffizienteM2RowData();
    this.gewichtungSpezifischesWissen = new KoeffizienteM2RowData();
    this.gewichtungVerantwortung = new KoeffizienteM2RowData();
    this.gewichtungPsychosozial = new KoeffizienteM2RowData();
    this.gewichtungKoerperlich = new KoeffizienteM2RowData();
    this.kendallTauB = new KoeffizienteM2RowData();
    this.pearson = new KoeffizienteM2RowData();
    this.nurTest1 = new KoeffizienteM2RowData();
    this.nurTest2 = new KoeffizienteM2RowData();
    this.nurTest3 = new KoeffizienteM2RowData();
    this.test1Plus2 = new KoeffizienteM2RowData();
    this.test1Plus3 = new KoeffizienteM2RowData();
    this.test2Plus3 = new KoeffizienteM2RowData();
    this.alleTests = new KoeffizienteM2RowData();
    this.koeffizientKonstante = new KoeffizienteM2RowData();
    this.koeffizientFunktionswert = new KoeffizienteM2RowData();
    this.koeffizientAlter = new KoeffizienteM2RowData();
    this.koeffizientDienstjahre = new KoeffizienteM2RowData();
    this.r2 = new KoeffizienteM2RowData();
  }
}
export class KoeffizienteM2RowData {
  analyseNurGrundlohn: string | number;
  analyseFixeGewichtung: string | number;
  standardAnalyseModell: string | number;
}
